//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEBaseBuilder.js";
import "../AME/AME.SelectAMEBaseNode.js";
import "../no/SelectObject.js";
let d=[[[0,"AdPropertyData",1,"AME.ADPropertyData",0],[1,"SelectedEclassProperty",0,"AME.SelectAMEBaseNode",0]],[[["selectedEClassProperty","selectedADPropertyId","selectedADPropertyName","selectedADPropertyDataType"],"MapEClassPropertyToADLibraryObjectProperty",{},4,0],[["selectedBMECatProperty","selectedADPropertyId","selectedADPropertyName","selectedADPropertyDataType"],"MapBMECatPropertyToADLibraryObjectProperty",{},4,0],[[],"UnMapEClassProperty",{},0,0],[[],"UnmapBMECatProperty",{},0,0],[["selectedEClassValue","selectedADValue"],"MapEClassPropertyValueToAdPropertyValue",{},2,0],[["selectedADValue"],"UnMapEClassPropertyValue",{},1,0],[["selectedEClassValueListId","selectedEClassValueId","selAdValueName"],"MapEClassGlobalValues",{},3,0],[["selectedEClassValueId"],"UnmapEClassGlobalValue",{},1,0]],[]];
SPLM.AME.ManageGlobalMappingBuilder = class extends SPLM.AME.AMEBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.ManageGlobalMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;